import { useEffect, useState, useContext } from 'react';
import { Button } from 'reactstrap';
import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';
import Table from '../ui/Table';
import ComponentCard from '../../layouts/containers/ComponentCard';
import gruposService from '../../services/http/gruposService';
import ModalClickable from '../../layouts/modals/ModalClickable';
import { AuthContext } from '../../context/authContext';
import Loader from '../../layouts/loader/Loader';
import logger from '../../services/logger';

const MostrarGrupos = ({ empresaId, ret }) => {
  const { userOU } = useContext(AuthContext);
  const [grupoDataa, setGrupoDataa] = useState([]);
  const [isSaved, setIsSaved] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchGrupoData = async () => {
      const grupoData = await gruposService.consultarGrupos({
        headquarter: empresaId,
      });

      const handleClonar = async (grupo) => {
        try {
          await gruposService.clonarGrupo({
            headquarter: empresaId,
            data: grupo,
          });

          // Mostrar modal y actualizar la tabla
          setIsSaved(true);
          await fetchGrupoData(); // Actualiza la tabla después de clonar
        } catch (error) {
          logger.error('Error al clonar el grupo:', error);
        }
      };
      // Añadir la columna "actions" con un botón a cada grupo
      const grupoDataWithActions = grupoData.map((grupo) => ({
        ...grupo,
        actions:
          userOU.centro === 'SUPERADMIN' ? (
            <Button color="primary" size="sm" onClick={() => handleClonar(grupo)}>
              Clonar
            </Button>
          ) : (
            'No hay acciones disponibles'
          ),
      }));

      setGrupoDataa(grupoDataWithActions);
    };
    fetchGrupoData();
  }, [empresaId, isSaved, userOU?.centro]);

  const handleRowDoubleClick = (row) => {
    const grupoId = row.original.codigo;
    navigate(`/grupos/detalles/${empresaId}/${grupoId}`);
  };

  return (
    <>
      {isSaved && <ModalClickable header="Grupo clonado correctamente." function={setIsSaved} />}
      <ComponentCard title="Listado de grupos" hasButton={false}>
        {grupoDataa.length > 0 ? (
          <Table
            columns={[
              {
                Header: 'ID',
                accessor: 'codigo',
              },
              {
                Header: 'Grupo',
                accessor: 'Grupo',
              },
              {
                Header: 'Horas',
                accessor: 'horas',
              },
              {
                Header: 'Area academica',
                accessor: 'areaAcademica',
              },
              {
                Header: 'Ley educativa',
                accessor: 'leyeducativa',
              },
              {
                Header: 'Máximo alumnos',
                accessor: 'maxAlumnos',
              },
              {
                Header: 'Disponible',
                accessor: 'Disponible',
              },
              {
                Header: 'Altas',
                accessor: 'altas',
              },
              {
                Header: 'Bajas',
                accessor: 'bajas',
              },
              {
                Header: 'Estado',
                accessor: 'Estado',
              },
              {
                Header: 'Acciones',
                Cell: ({ original }) => original.actions,
                sortable: false,
                filterable: false,
              },
            ]}
            data={grupoDataa}
            defaultPageSize={10}
            showPaginationBottom
            className="-striped -highlight mt-5 text-center"
            getTrProps={(state, rowInfo) => ({
              onDoubleClick: () => handleRowDoubleClick(rowInfo),
            })}
          />
        ) : (
          <Loader />
        )}
        <Button className="float-left mt-4" onClick={ret}>
          Atrás
        </Button>
      </ComponentCard>
    </>
  );
};

MostrarGrupos.propTypes = {
  empresaId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  ret: PropTypes.func,
};
export default MostrarGrupos;
